import React from 'react';
import PropTypes from 'prop-types';

import Item from '@stubhub/react-event-item';

import './index.scss';

/**
 * A list of event-item, this is specific to discovery's EventList as their List component is stateless
 */

const EventList = ({onEventItemClick, events, ...eventItemOptions}) =>
  !events || !events.length
    ? null
    : events.map((event, index) => (
        <Item
          event={event}
          key={event.id}
          onClick={() => onEventItemClick && onEventItemClick(event, index)}
          {...eventItemOptions}
        />
      ));

EventList.propTypes = {
  events: PropTypes.array,
  threshold: PropTypes.number,
  type: PropTypes.string,
  onEventItemClick: PropTypes.func,

  /**
   * Flag to Turn on the View Tickets Feature
   *
   */
  enableViewTickets: PropTypes.bool,

  /**
   * Options Containing the Parts of the Event Items to be Hidden
   *
   */
  eventItemDisplayOptions: PropTypes.object,
};

export default EventList;
